<div class="innerpage-fullwithbanner">
    <h2 class="bighead">My Properties</h2>
    <ul class="bread-crumbs">
        <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
        <li>Properties</li>
    </ul>
</div>
<div class="featuredproperties section-margin be-data-entry-page">
    <div class="container container-lg min-heightcontainer table-fixed">
        <div class="border-div">
            <div class="row margin-bottom-5">
                <div class="col-sm-4">
                    <label class="form-label">
                        Brokerage
                        <!--<span class="star">*</span>-->
                    </label>
                    <label class="select">
                        <select [(ngModel)]="brokerageId" class="form-control" (change)="onChangeBrokerage()">
                            <option [ngValue]="0">View All</option>
                            <option *ngFor="let brokerage of brokerageList" [(ngValue)]="brokerage.Id">{{brokerage.BrokerageName}}</option>
                            <option [ngValue]="null">No Brokerage</option>
                        </select>
                        <i></i>
                    </label>
                </div>
                <div class="col-sm-6">
                    <div class="margin-bottom-15  margin-right-10 displayinlineblockdiv" style="float:left">
                        <label class="form-label">
                            Bulk Actions
                        </label>
                        <label class="select">
                            <select class="form-control" [(ngModel)]="selectedAction" (change)="onActionSelect($event,bulkAction,'panlestyle',CompOrArchive);" style="width:175px">
                                <option value="0">Select</option>
                                <option value="1">Change Status</option>
                                <!--<option value="2">Mark As Comp</option>-->
                                <option value="3">Mark As Archive</option>
                                <option value="7">Verify</option>
                            </select>
                            <i></i>
                        </label>

                    </div>
                    <p *ngIf="selectedRows?.length > 0" class="selected-rows-count pull-left ">
                        <label class="form-label">&nbsp;</label>
                        {{selectedRows?.length}} row{{selectedRows?.length == 1 ? '':'s'}} selected
                        <a class="remove" tooltip="Remove Selection" href="javascript:void(0);" (click)="resetSelectedRows();"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                    </p>
                </div>
                <div class="col-sm-2">
                    <div class="btn-group right-btn rightdropdown pull-right" dropdown>
                        <button id="button-basic" dropdownToggle type="button" class="btn  btn-circle btn-green margin-bottom dropdown-toggle"
                                aria-controls="dropdown-basic">
                            <i aria-hidden="true" class="fa fa-plus icon"></i>
                        </button>
                        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-basic">
                            <li role="menuitem"><a class="dropdown-item" href="#" [routerLink]="['/dataentry-property']">Add Property</a></li>
                            <li role="menuitem"><a class="dropdown-item" href="#" [routerLink]="['/dataentry-property']" [queryParams]="{isPortfolio:true}">Add Portfolio</a></li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="row margin-bottom-15">
                <div class="col-sm-6">
                    <div>
                        <ul class="statuslisting doc-listing user-listing margin-bottom-0">
                            <li class="transition" style="border: 1px solid #d8d0d0;" [class.active]="isAvailable == true">
                                <a href="javascript:void(0);" (click)="filterByStatus(propertyStatus.Available,$event)">
                                    <h3 style="color:#e47220">{{available}}</h3>
                                    <h4 style="color:black">Live Listings</h4>

                                </a>
                            </li>
                            <li class="transition" style="border: 1px solid #d8d0d0;" [class.active]="isPending == true">
                                <a href="javascript:void(0);" (click)="filterByStatus(propertyStatus.PendingApproval,$event)">
                                    <h3 style="color:#28a436">{{pending}}</h3>
                                    <h4 style="color:black">Pending</h4>
                                </a>
                            </li>
                            <li class="transition" style="border: 1px solid #d8d0d0;" [class.active]="isRejected == true">
                                <a href="javascript:void(0);" (click)="filterByStatus(propertyStatus.Rejected,$event)">
                                    <h3 style="color:#fb4338">{{rejected}}</h3>
                                    <h4 style="color:black">Rejected</h4>
                                </a>
                            </li>
                            <li class="transition" style="border: 1px solid #d8d0d0;" [class.active]="isDraft == true">
                                <a href="javascript:void(0);" (click)="filterByStatus(propertyStatus.Draft,$event)">
                                    <h3 style="color:#fb4338">{{draft}}</h3>
                                    <h4 style="color:black">Draft</h4>
                                </a>
                            </li>
                            <li class="transition" style="border: 1px solid #d8d0d0;" [class.active]="isviewAll == true">
                                <a href="javascript:void(0);" (click)="reset()">
                                    <h3 style="color:#fb4338">{{totalCountBrokerage}}</h3>
                                    <h4 style="color:black">View All</h4>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="floatinghead floatinghead-xs clearfix">
                        <!--<h2 class="mainhead "><span class="text">Registered Users</span></h2>-->
                        <!--<label class="form-label">&nbsp;</label>-->

                        <div class="rightside clearfix">
                            <label class="form-label">&nbsp;</label>
                            <div class="search-sec margin-bottom-0 margin-right-10">
                                <input class="form-control" type="text" [(ngModel)]="searchText" (keyup)="onSearch($event.target.value)" placeholder="Tenant/Brokerage/Brokerage URL">
                                <i class="fa fa-search icon" aria-hidden="true"></i>
                            </div>
                        </div>
                        <!--<p *ngIf="totalCount > 0">Showing {{totalCount}} properties out of {{totalCountBrokerage}}</p>-->

                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
                    <thead>
                      <tr>
                        <th style="position:static; cursor:default" ng-disabled="true" data-orderable="false">
                          <label class="custom-checkbox withoutlabel">
                            <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>
                          </label>
                        </th>
                        <th data-orderable="false">Action</th>
                        <th style="display:none" class="min-width-td">Guid</th>
                        <th style="width:10px;" class="min-width-td" [hidden]="true">Property Id</th>
                        <th style="width:150px;" class="min-width-td">Tenant</th>
                        <th>State</th>
                        <th class="min-width-75">City</th>
                        <th class="whitespacenowrap">Asking Price</th>
                        <th>Property/Portfolio Status</th>
                        <th>Cap Rate</th>
                        <th>Source URL</th>
                        <th>Updated</th>
                        <th style="width:150px;" class="min-width-60">Recent Activity</th>
                        <!--none; width:150px">DDFilePath</th>-->
                        <!--<th style="width:60px">Attachments</th>-->
                        <th data-orderable="false">OM</th>
                        <th data-orderable="false">DD</th>
                        <th style="width:50px">Comments</th>

                      </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of propertyList;let i = index ">
                          <tr [class.portfoio-list]="item.IsPortfolio">
                            <td>
                              <label class="custom-checkbox withoutlabel">
                                <input type="checkbox" [(ngModel)]="item.IsSelected" (change)="onCheckboxChange($event,item.Id,item.Type);" class="ng-pristine ng-valid ng-touched"><i></i>
                              </label>
                            </td>
                            <td style="white-space:nowrap;">

                              <a href="javascript:void(0);" *ngIf="item.Type == 1" routerLink="/dataentry-property/{{item.Guid}}" [queryParams]="{prevroute:'My Properties',link:router.url, isPortfolio:item.IsPortfolio}" class="blueone" tooltip="Edit" placement="right">
                                <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                              </a>
                              <a href="javascript:void(0);" *ngIf="item.Type == 2" routerLink="/property/{{item.Guid}}" [queryParams]="{prevroute:'My Properties',link:router.url, isPortfolio:item.IsPortfolio}" class="blueone" tooltip="Edit" placement="right">
                                <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                              </a>
                              <a href="javascript:void(0);" class="blueone" tooltip="Verified" (click)="VerifyProperty(item.Id,item.Type, item)" placement="right">
                                <i class="icofont icofont-ui-check" aria-hidden="true"></i>
                              </a>
                              <a href="javascript:void(0);" class="blueone quick-edit" tooltip="Quick Edit" (click)="openModalForQuickEdit(QuickEdit,'panlestyle',item.Guid,item.StateName,item.CityName,item.BrokerageName,item.Type)" placement="right">
                                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                              </a>


                            </td>
                            <td [hidden]="true">
                              <p class="d-flex">
                                {{item.PropertySequenceId ? item.PropertySequenceId : '-'}}
                              </p>
                            </td>
                            <td class="sticky-left first-td">
                              <p class="d-flex">
                                <span style="position:static;margin-right:5px;" *ngIf="item.IsPortfolio" (click)="showPortfolioProperties(item.Id, i)" class="btn-collapse" [class.span-open]="this.propertyList[i].ShowPortfolioProperties">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </span>
                                <a *ngIf="item.Type == 1" href="javascript:void(0);" routerLink="/viewdeproperty/{{item.Guid}}" [queryParams]="{'prevroute':'Property List',link:'property-listing'}">{{ item.PropertyName }}</a>
                                <a *ngIf="item.Type == 2" href="javascript:void(0);" routerLink="/viewproperty/{{item.Guid}}" [queryParams]="{'prevroute':'Property List',link:'property-listing'}">{{ item.PropertyName }}</a>
                                <a href="javascript:void(0);" class="blueone" *ngIf="item.HasDuplicate" tooltip="View Duplicates" (click)="openModalForDuplicates(DuplicateProperty,'panlestyle',item.Id)" placement="right" style="line-height:18px;">
                                  <i class="fa fa-files-o" style="font-size:18px;" aria-hidden="true"></i>
                                </a>
                              </p><sub>{{item.PropertySequenceId}}</sub>
                              <p>{{item.Address}}</p>
                            </td>
                            <td>
                              <p>{{item.StateName ? item.StateName : '-'}}</p>
                            </td>
                            <td>
                              <p>{{item.CityName ? item.CityName : '-'}}</p>
                            </td>
                            <td>
                              <p class="whitespacenowrap" *ngIf="item.Unpriced" >Unpriced</p>
                              <p class="whitespacenowrap" *ngIf="!item.Unpriced">{{(item.Price) ? '$ '+ (item.Price | number:0) : '-'}}</p>
                            </td>
                            <td><p [ngClass]="{'redtextlabel':(item.PropertyStatus === 'Closed' || item.PropertyStatus === 'Sold'),'greentextlabel':item.PropertyStatus === 'Available','orangetextlabel':item.PropertyStatus === 'Under Contract','not-available':item.PropertyStatus === 'Not Available','Off-Market':item.PropertyStatus === 'Off-Market', 'darkbluetextlabel':item.PropertyStatus === 'Pending Approval'}">{{ item.PropertyStatus }}</p></td>
                            <td ><p *ngIf="item.capRateText == 'ZCF'">{{item.capRateText}}</p>
                            <p *ngIf="item.capRateText != 'ZCF'" class="whitespacenowrap">{{ (item.CapRate) ? (item.CapRate | number : '1.2-2') + '%' : '-'}}</p></td>
                            <td>

                              <p *ngIf="item.WebsiteURL" style="margin:5px 0 0 -3px" class="whitespacenowrap"><a href="javascript:void(0);" target="_blank" [href]="item.WebsiteURL"><i class="fa fa-external-link" aria-hidden="true"></i> View Site</a></p>
                            </td>
                            <td>
                              <p *ngIf="!item.AuditTrailLogId">New Property</p>
                              <a class="blueone" href="javascript:void(0);" *ngIf="item.AuditTrailLogId" (click)="openModalForAuditTrailDetail(template,'commonmodal activitylogmodal',item.AuditTrailLogId)" placement="top" container="body" tooltip="Activity log detail"><i aria-hidden="true" class="icofont icofont icofont-info"></i></a>

                            </td>

                            <td>
                              <p style="width:70px;word-break:break-all">{{Validation.convertUTCDateToLocalDate(item.RecentActivity)| date:'MM/dd/yyyy h:mm a'}}</p>
                            </td>
                            <td>
                              <a *ngIf="isDocumentLoaded" style="white-space:nowrap" (click)="downloadAllDoc(item.Documents,1,$event)" [ngClass]="{'border-link':(item.OMFileCount > 0)}"><i *ngIf="item.OMFileCount > 0" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{item.OMFileCount > 0?'OM (' + item.OMFileCount+')':'-'}}</a>
                              <div *ngIf="!isDocumentLoaded" class="displayinlineblockdiv">
                                <i class="imageicon fa fa-circle-o-notch fa-spin fa-3x fa-fw" aria-hidden="true"></i>
                              </div>
                            </td>
                            <td>
                              <a *ngIf="isDocumentLoaded" style="white-space:nowrap" (click)="downloadAllDoc(item.Documents,2,$event)" [ngClass]="{'border-link':(item.DDFileCount > 0)}"><i *ngIf="item.DDFileCount > 0" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{item.DDFileCount > 0?'DD (' + item.DDFileCount+')':'-'}}</a>
                              <div *ngIf="!isDocumentLoaded" class="displayinlineblockdiv">
                                <i class="imageicon fa fa-circle-o-notch fa-spin fa-3x fa-fw" aria-hidden="true"></i>
                              </div>
                            </td>
                            <td>
                              {{item.Comments ? item.Comments.substr(0,15) : '-'}}
                              <a *ngIf="item.Comments?.length > 15 " style="cursor:pointer" href="javascript:void(0);" popover="{{item.Comments}}" placement="left" container="body" triggers="mouseenter:mouseleave">...</a>
                            </td>

                          </tr>
                            <ng-container *ngIf="this.propertyList[i].ShowPortfolioProperties">
                              <tr *ngFor="let propChild of item.PortfolioProperties; let k=index" (click)="selecteRow(k)" [class.tr-collapse]="this.propertyList[i].ShowPortfolioProperties">
                                <td>
                                </td>
                                <td style="white-space:nowrap;">

                                  <a href="javascript:void(0);" *ngIf="propChild.Type == 1" routerLink="/dataentry-property/{{propChild.Guid}}" [queryParams]="{prevroute:'My Properties',link:router.url, isPortfolio:propChild.IsPortfolio}" class="blueone" tooltip="Edit" placement="right">
                                    <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                                  </a>
                                  <a href="javascript:void(0);" *ngIf="propChild.Type == 2" routerLink="/property/{{propChild.Guid}}" [queryParams]="{prevroute:'My Properties',link:router.url, isPortfolio:propChild.IsPortfolio}" class="blueone" tooltip="Edit" placement="right">
                                    <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                                  </a>
                                  <a href="javascript:void(0);" class="blueone" tooltip="Verified" (click)="VerifyProperty(propChild.Id,propChild.Type)" placement="top">
                                    <i class="icofont icofont-ui-check" aria-hidden="true"></i>
                                  </a>
                                  <a href="javascript:void(0);" class="blueone quick-edit" tooltip="Quick Edit" (click)="openModalForQuickEdit(QuickEdit,'panlestyle',propChild.Guid,propChild.StateName,propChild.CityName,propChild.BrokerageName,propChild.Type)" placement="right">
                                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                  </a>
                                </td>
                                <td class="sticky-left first-td">
                                  <p class="d-flex">
                                    <a *ngIf="propChild.Type == 1" href="javascript:void(0);" routerLink="/viewdeproperty/{{propChild.Guid}}" [queryParams]="{'prevroute':'Property List',link:'property-listing'}">{{ propChild.PropertyName }}</a>
                                    <a *ngIf="propChild.Type == 2" href="javascript:void(0);" routerLink="/viewproperty/{{propChild.Guid}}" [queryParams]="{'prevroute':'Property List',link:'property-listing'}">{{ propChild.PropertyName }}</a>
                                    <a href="javascript:void(0);" class="blueone" *ngIf="propChild.HasDuplicate" tooltip="View Duplicates" (click)="openModalForDuplicates(DuplicateProperty,'panlestyle',propChild.Id)" placement="auto" style="line-height:32px;">
                                      <i class="fa fa-files-o" style="font-size:18px;" aria-hidden="true"></i>
                                    </a>
                                  </p><sub>{{propChild.PropertySequenceId}}</sub>
                                  <p>{{propChild.Address}}</p>
                                </td>
                                <td>
                                  <p>{{propChild.StateName ? propChild.StateName : '-'}}</p>
                                </td>
                                <td>
                                  <p>{{propChild.CityName ? propChild.CityName : '-'}}</p>
                                </td>
                                <td class="whitespacenowrap">
                                  <p  *ngIf="propChild.Unpriced">Unpriced</p>
                                  <p *ngIf="!propChild.Unpriced">{{(propChild.Price) ? '$ '+ (propChild.Price | number:0) : '-'}}</p>
                                </td>
                                <td><p [ngClass]="{'redtextlabel':(propChild.PropertyStatus === 'Closed' || propChild.PropertyStatus === 'Sold'),'greentextlabel':propChild.PropertyStatus === 'Available','orangetextlabel':propChild.PropertyStatus === 'Under Contract','not-available':propChild.PropertyStatus === 'Not Available','Off-Market':propChild.PropertyStatus === 'Off-Market', 'darkbluetextlabel':propChild.PropertyStatus === 'Pending Approval'}">{{ propChild.PropertyStatus }}</p></td>
                                <td>
                                  <p *ngIf="propChild.capRateText == 'ZCF'">{{propChild.capRateText}}</p>
                                  <p *ngIf="propChild.capRateText != 'ZCF'" class="whitespacenowrap">{{ (propChild.CapRate) ? (propChild.CapRate | number : '1.2-2') + '%' : '-'}}</p>
                                </td>
                                <td>
                                  <p *ngIf="propChild.WebsiteURL" style="margin:5px 0 0 -3px" class="whitespacenowrap"><a href="javascript:void(0);" target="_blank" [href]="propChild.WebsiteURL"><i class="fa fa-external-link" aria-hidden="true"></i>View Site </a></p>
                                </td>
                                <td>
                                  <p *ngIf="!propChild.AuditTrailLogId">New Property</p>
                                  <a class="blueone" href="javascript:void(0);" *ngIf="propChild.AuditTrailLogId" (click)="openModalForAuditTrailDetail(template,'commonmodal activitylogmodal',propChild.AuditTrailLogId)" placement="top" container="body" tooltip="Activity log detail"><i aria-hidden="true" class="icofont icofont icofont-info"></i></a>

                                </td>

                                <td>
                                  <p>{{Validation.convertUTCDateToLocalDate(propChild.RecentActivity)| date:'MM/dd/yyyy h:mm a'}}</p>
                                </td>
                                <td>
                                  <a style="white-space:nowrap" (click)="downloadAllDoc(propChild.Documents,1,$event)" [ngClass]="{'border-link':(propChild.OMFileCount > 0)}"><i *ngIf="propChild.OMFileCount > 0" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{propChild.OMFileCount > 0?'OM (' + propChild.OMFileCount+')':'-'}}</a>
                                </td>
                                <td>
                                  <a style="white-space:nowrap" (click)="downloadAllDoc(propChild.Documents,2,$event)" [ngClass]="{'border-link':(propChild.DDFileCount > 0)}"><i *ngIf="propChild.DDFileCount > 0" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{propChild.DDFileCount > 0?'DD (' + propChild.DDFileCount+')':'-'}}</a>
                                </td>
                                <td [hidden]="propertyStatusId == propertyStatus.Available">
                                  {{propChild.Comments ? propChild.Comments.substr(0,15) : '-'}}
                                  <a *ngIf="propChild.Comments?.length > 15 " style="cursor:pointer" href="javascript:void(0);" popover="{{propChild.Comments}}" placement="top" container="body" triggers="mouseenter:mouseleave">...</a>
                                </td>

                              </tr>
                            </ng-container>
                        </ng-container>
</tbody>
                    <tfoot>
                        <tr *ngIf="propertyList?.length == 0&&!IsPropLoading ">
                            <td colspan="10" class="odd no-data-available">
                                <div class="nodata">
                                    <i class="fa fa-exclamation-triangle icon"></i>
                                    <p>No Properties Available</p>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

    </div>
</div>


<ng-template #BrokerageTemplate>
    <app-brokerage-add [modalRef]="modalRef" [item]="item" (closeModal)="closeModal($event)"></app-brokerage-add>
</ng-template>
<ng-template #BrokerTemplate>
    <app-broker-add [modalRef]="modalRef" [item]="item" (closeModal)="closeModal($event)"></app-broker-add>
</ng-template>
<ng-template #template class="pull-left">
    <app-audit-trail-details [modalRef]="modalRef" [auditTrailId]="AuditId"></app-audit-trail-details>
</ng-template>

<ng-template #DeleteBrokerageTemplate>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Delete Brokerages</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue">Deleting the brokerages will also delete the {{brokersCount}} brokers associated with it. Are you sure you want to proceed ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRef.hide()">No</button>
            <button class="btn btn-lg btn-danger" (click)="DeleteBrokerage()">Yes</button>
        </div>
    </div>
</ng-template>
<ng-template #DeleteBrokerTemplate>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Delete Brokers</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue"> Are you sure you want to delete ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRef.hide()">No</button>
            <button class="btn btn-lg btn-danger" (click)="DeleteBroker()">Yes</button>
        </div>
    </div>
</ng-template>
<ng-template #QuickEdit>
    <app-quick-edit-property [selectedPropertyId]="selectedPropertyId" [quickEditDetails]="quickEditDetails" (closeModal)="closeModal($event)" [isDataEntryProperty]="isDataEntryProperty"></app-quick-edit-property>
</ng-template>


<ng-template #bulkAction>

    <div class="modal-header">
        <h4 class="modal-title pull-left">Change Status</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">
        <div class="form-group">
            <label class="form-label">
                Change Status of selected {{getSelectedCount()}} properties
                <span class="star">*</span>
            </label>
            <label class="select">
                <select [(ngModel)]="statusToChange" #propStatus="ngModel" class="form-control">
                    <option value="0">--Select--</option>
                    <option [ngValue]="item.id" *ngFor="let item of propertyStatusList">{{item.description}}</option>
                </select>
                <i></i>
            </label>
            <p class="redtext" *ngIf="showSelectStatus || (propStatus.touched && statusToChange == 0)">Please select status</p>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
            <button class="btn btn-success btn-lg" (click)="changeStatus();">Update</button>
        </div>
    </div>

</ng-template>


<ng-template #CompOrArchive>

    <div class="modal-header">
        <h4 class="modal-title pull-left">{{ConfirmationHeading}}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">

        <div class="form-group">
            <h6 class="displayvalue">{{confirmBody}}</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
            <button class="btn btn-success btn-lg" (click)="markCompOrArchive();modalRef.hide();">Update</button>
        </div>
    </div>

</ng-template>
<ng-template #DuplicateProperty>
    <app-duplicate-property-list [PropertyId]="selectedPropertyIdForDuplicates" [modalRef]="modalRefDuplicates" [Type]="2"></app-duplicate-property-list>
</ng-template>
